import { memo } from "react";
import { ThreeDots } from "react-loader-spinner";

const AppLoader = () => {
    return (
        <div
            className="vh-100 vw-100 position-fixed d-flex justify-content-center align-items-center z-3"
            style={{ backgroundColor: "#2a2a2a" }}
        >
            <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#b68b47"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
            />
        </div>
    );
};

export default memo(AppLoader);
